import { createSlice } from '@reduxjs/toolkit'
import { useDispatch, useSelector } from '@Store/store'
import Sentry from '@Utils/Sentry'

export interface CacheState {
  me?: any
  rootMe?: any
  meBilling?: any
}

const initialState: CacheState = {
  me: undefined,
  rootMe: undefined,
  meBilling: undefined,
}
const cacheSlice = createSlice({
  name: 'cache',
  initialState,
  reducers: {
    setMe: (state, action) => {
      state.me = action.payload

      const { id, name, email } = action.payload || {}

      Sentry.setUser({ id, username: name, email })
    },
    setRootMe: (state, action) => {
      // Set-once from root panel tokens. Use clearRootMe() to drop and re-seed
      // (e.g. when the merchant's company info changes upstream and needs to
      // be refreshed on next visit to a panel-switcher consumer).
      if (state.rootMe) return
      state.rootMe = action.payload
    },
    clearRootMe: (state) => {
      state.rootMe = undefined
    },
    setMeBilling: (state, action) => {
      state.meBilling = action.payload
    },
    invalidate: (state, action: { payload: (keyof CacheState)[] }) => {
      const keysToInvalidate = action.payload
      keysToInvalidate.forEach((key) => {
        if (key in state) {
          state[key] = undefined

          if (key === 'me') {
            Sentry.clearUser()
          }
        }
      })
    },
  },
})

const { actions, reducer } = cacheSlice

const useCacheState = (): CacheState => useSelector((state) => state.cache)

const useCacheActions = () => {
  const dispatch = useDispatch()

  return {
    setMe: (payload: any) => dispatch(actions.setMe(payload)),
    setRootMe: (payload: any) => dispatch(actions.setRootMe(payload)),
    clearRootMe: () => dispatch(actions.clearRootMe()),
    setMeBilling: (payload: any) => dispatch(actions.setMeBilling(payload)),
    invalidate: (payload: (keyof CacheState)[]) => {
      dispatch(actions.invalidate(payload))
    },
  }
}

export default reducer
export { useCacheState, useCacheActions }
